import { render, staticRenderFns } from "./Defeated.vue?vue&type=template&id=37c7916c&scoped=true"
var script = {}
import style0 from "./Defeated.vue?vue&type=style&index=0&id=37c7916c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c7916c",
  null
  
)

export default component.exports